import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=b5cd9cb6&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=b5cd9cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cd9cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5cd9cb6')) {
      api.createRecord('b5cd9cb6', component.options)
    } else {
      api.reload('b5cd9cb6', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=b5cd9cb6&scoped=true&", function () {
      api.rerender('b5cd9cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LvR7dwUC1mOC/JS/comp/DateRangeExt.vue"
export default component.exports